export class RoomFieldParameter {
  forceSelection: boolean | undefined;
  myRoom: boolean | undefined; // Only for frontend to prefill the field. The user can still change it e.a. if he has no room in speedikon.
}
